import { render, staticRenderFns } from "./UserBlock.vue?vue&type=template&id=35fbcb7d&scoped=true&"
import script from "./UserBlock.vue?vue&type=script&lang=js&"
export * from "./UserBlock.vue?vue&type=script&lang=js&"
import style0 from "./UserBlock.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserBlock.vue?vue&type=style&index=1&id=35fbcb7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fbcb7d",
  null
  
)

export default component.exports